const { createSelector } = require('reselect')
const selectCategories = state => state['marketplace.categories'].getCategories

const getCategories = () => createSelector(
  [selectCategories],
  prof => prof.data,
)

const getCategoriesError = () => createSelector(
  [selectCategories],
  prof => prof.error,
)

const getCategoriesLoading = () => createSelector(
  [selectCategories],
  prof => prof.loading,
)


module.exports = {
  getCategories,
  getCategoriesError,
  getCategoriesLoading,

}
